import { connect } from 'react-redux'
import { actions } from '../modules/CreateUser'
import CreateUserPage from '../components/CreateUserPage'
import { setNavBarProps } from 'store/navbar'

const mapStateToProps = (state, ownProps) => {
  let pageType = 'edit'
  if (state.location.pathname === '/users/create') {
    pageType = 'create'
    state.userReducer.user.created_by = state.user.id
  } else if (state.location.pathname === '/users/me') {
    pageType = 'profile'
  } else if (parseInt(state.location.pathname.split('/').slice(-1)[0]) === state.user.id) {
    pageType = 'profile'
  }

  return {
    ...state.userReducer,
    pageType,
    currentUser: state.user,
    loading: state.loading.general
  }
}

const mapDispatch = { ...actions, setNavBarProps }

export default connect(
  mapStateToProps,
  mapDispatch
)(CreateUserPage)
